import React, { useState, useMemo } from 'react';
import AdminSearchTable from '../Admin/AdminSearchTable'
import FilterIcon from '../../SVG/Filter';

const ClaimsHistoryMajorMedSection = ({ model }) => {
    const allClaims = model?.claimsMMHistory || [];
    const authToken = "19b5ec46-b847-4286-b933-7488c61bba77";  // TODO: move to env var

    // Date filter states
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Columns definition for the table
    const columns = [
        { label: 'Provider Name', accessor: 'providerName' },
        { label: 'Service Date', accessor: 'serviceDatesMin' },
        { label: 'Billed Amount', accessor: 'billedAmtProvider' },
        { label: 'Allowed Amount', accessor: 'allowedAmount' },
        { label: 'Amount Paid', accessor: 'amountCoveredDisplay' },
        { label: 'Benefit Note', accessor: 'benefitCodeDesc' },
        {
            label: 'EOB',
            accessor: 'viewEOB',
            Cell: (row) => {
                if (!row.claimIDNum || !model.polNo) return null;

                const claimNumber = row.claimIDNum;
                const memberId = model.polNo.substring(0, 10);

                const href = `https://api.redcard.com/Source/ViewClaimsDocument.aspx?authtoken=${authToken}&recipientType=Insured&claimNumber=${claimNumber}&memberid=${memberId}`;

                return (
                    <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="baseButton small"
                    >
                        View
                    </a>
                );
            },
        },
    ];

    // Filter claims based on serviceDatesMin date range
    const filteredClaims = useMemo(() => {
        if (!startDate && !endDate) return allClaims;

        return allClaims.filter(claim => {
            if (!claim.serviceDatesMin) return false; // skip if no date

            const serviceDate = new Date(claim.serviceDatesMin);
            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;

            if (start && end) return serviceDate >= start && serviceDate <= end;
            if (start) return serviceDate >= start;
            if (end) return serviceDate <= end;

            return true;
        });
    }, [allClaims, startDate, endDate]);

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
    };

    if (allClaims.length === 0) {
        return (
            <div className="container container-section" id="claims-history-container">
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <div className="flex-container">
                            <h5>No Claims Found</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container container-section" id="claims-history-container">
            <div className="filter-box">
                <FilterIcon/>
                <div className="filter-item">
                    <label htmlFor="startDate" className="filterLabel">Start Date</label>
                    <input
                        type="date"
                        id="startDate"
                        className="filterInput"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                    />
                </div>
                <div className="filter-item">
                    <label htmlFor="endDate" className="filterLabel">End Date</label>
                    <input
                        type="date"
                        id="endDate"
                        className="filterInput"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                    />
                </div>
                <div className="filter-item align-end">
                    <button
                        type="button"
                        className="filterButton"
                        onClick={handleClear}
                    >
                        Clear
                    </button>
                </div>
            </div>

            <AdminSearchTable columns={columns} data={filteredClaims} />
        </div>
    );
};

export default ClaimsHistoryMajorMedSection;
